'use client';

import { useEffect, useRef, useState } from 'react';
import { useTheme } from '../context/ThemeContext';

export default function ThemeTransition() {
  const { theme, isDark } = useTheme();
  const overlayRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [mounted, setMounted] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Handle initial load
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 50);
    return () => clearTimeout(timer);
  }, []);

  // Handle theme change
  useEffect(() => {
    if (overlayRef.current) {
      // Show overlay during transition
      overlayRef.current.classList.add('visible');
      
      // Hide overlay after transition
      timeoutRef.current = setTimeout(() => {
        if (overlayRef.current) {
          overlayRef.current.classList.remove('visible');
        }
      }, 300);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [theme, isDark]);

  if (!mounted) return null;

  return (
    <div 
      ref={overlayRef} 
      className="theme-transition-overlay"
      style={{
        backgroundColor: isDark ? '#121212' : '#fafafa',
      }}
    />
  );
} 